var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { formatNumber } from '@debbie/common/dist';
import helpers from '@debbie/common/dist/economy/helpers';
import * as paymentPlanHelpers from '@debbie/common/dist/economy/payment-plans';
import { h } from '@debbie/cortex/dist';
import { paymentPlans as paymentPlansApi } from '@debbie/cortex/dist/api';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import { Checkbox, Table, Badge, RadioSelect, PlaceholderLoader, Alert, Errors, ExclusiveContent, } from '../';
import THEME from '../../theme';
import Button from '../Button';
import { Edit, ArrowRight } from '../Icons';
import Money from '../Money';
import CustomPlanForm from './CustomPlanForm';
import PaymentPlanData from './PaymentPlanData';
import PaymentPlanTable from './PaymentPlanTable';
import Plan, { StyledPlan } from './Plan';
import { getExpirationSettings, } from '@debbie/common/dist/economy/helpers/interest';
import { paymentPlansByCaseIdKey, usePaymentPlansByCaseId, } from '@debbie/cortex/dist/paymentPlans';
import q from '@debbie/cortex/dist/query';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents';
import { CaseStatus } from '@debbie/common/dist/cases';
import AlertCmp from '../Alert';
import { getBalance } from '@debbie/common/dist/economy/helpers/payment-plans';
import { useCreditor } from '@debbie/cortex/dist/creditors';
const PaymentPlanCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const paymentPlansLoadable = usePaymentPlansByCaseId(props.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const paymentPlansIsLoading = h.isLoading(paymentPlansLoadable);
    const documentsLoader = useDocumentsByReference(props.caseId);
    const documents = h.hasData(documentsLoader) ? documentsLoader.data : null;
    const creditorLoadable = useCreditor(singleCase === null || singleCase === void 0 ? void 0 : singleCase.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [plan, setPlan] = useState([]);
    const [config, setConfig] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activationTrigger, setActivationTrigger] = useState(true);
    const [customPlanEditor, setCustomPlanEditor] = useState(true);
    const [standardPlans, setStandardPlans] = useState(null);
    const paymentPlan = paymentPlans && paymentPlanHelpers.getCurrentPaymentPlan(paymentPlans);
    const selectPlan = (id, plan, config) => {
        setSelectedPlan(id);
        setPlan(plan);
        setConfig(config);
    };
    const createPaymentPlan = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield paymentPlansApi.create(props.caseId, {
                activationTrigger,
                plan: plan.map((entry) => ({
                    amount: entry.amount,
                    cancel: entry.cancel,
                    deadline: entry.deadline,
                    reminder: entry.reminder,
                    date: entry.date,
                    type: entry.type,
                })),
                config: config
                    ? {
                        interval: config.interval,
                        startDate: config.startDate,
                        duration: config.duration,
                        amount: config.amount,
                        amountUpfront: config.amountUpfront,
                        dateUpfront: config.dateUpfront,
                        interestFree: config.interestFree,
                    }
                    : null,
            });
            q.invalidate([paymentPlansByCaseIdKey(props.caseId)]);
        }
        catch (e) {
            console.error(e);
            alert('An error occurred.');
        }
        setLoading(false);
    });
    useEffect(() => {
        if (tenant && creditor) {
            const { plans } = creditor.paymentPlansConfig ||
                tenant.paymentPlansConfig ||
                paymentPlanHelpers.defaultPaymentPlansConfig;
            setStandardPlans(plans);
        }
    }, [tenant, creditor]);
    const paymentPlanConfig = (creditor === null || creditor === void 0 ? void 0 : creditor.paymentPlansConfig) ||
        (tenant === null || tenant === void 0 ? void 0 : tenant.paymentPlansConfig) ||
        paymentPlanHelpers.defaultPaymentPlansConfig;
    return (React.createElement(PaymentPlanCreatorStyled, null, paymentPlanConfig.disablePaymentPlans ? (React.createElement(Alert, { message: lang.paymentPlans.paymentPlansDisabled })) : (React.createElement(React.Fragment, null,
        React.createElement("div", null, paymentPlansIsLoading ? (React.createElement(PlaceholderLoader, null)) : (!paymentPlan && (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(RadioSelect, { label: lang.paymentPlans.createCustomPlan, active: customPlanEditor, onClick: () => {
                        setCustomPlanEditor(true);
                        selectPlan(null, [], config);
                    } }),
                React.createElement(RadioSelect, { label: lang.paymentPlans.createStandardPlan, active: !customPlanEditor, onClick: () => {
                        setCustomPlanEditor(false);
                        selectPlan(null, [], config);
                    } }),
                React.createElement("br", null),
                React.createElement("br", null),
                customPlanEditor ? (React.createElement("div", null,
                    React.createElement(CustomPlanForm, { creditor: creditor, caseId: props.caseId, selectPlan: selectPlan, caseVouchers: props.caseVouchers }),
                    selectedPlan === 'CUSTOM' && (React.createElement(StyledPlan, { active: true },
                        React.createElement("div", { className: "price" }, plan[0] && (React.createElement("span", null,
                            React.createElement(Money, { amount: paymentPlanHelpers.getAmount.entry(plan) || 0 }),
                            React.createElement("div", null,
                                singleCase && singleCase.currency,
                                "/",
                                lang.paymentPlans.month),
                            paymentPlanHelpers.getAmount.upfront(plan) && (React.createElement("div", { className: "pp-details" },
                                React.createElement("span", null,
                                    lang.paymentPlans.upfrontPayment,
                                    ":"),
                                ' ',
                                React.createElement(Money, { amount: paymentPlanHelpers.getAmount.upfront(plan) || 0 }))),
                            paymentPlanHelpers.getAmount.rest(plan) && (React.createElement("div", { className: "pp-details" },
                                React.createElement("span", null,
                                    lang.paymentPlans.rest,
                                    ":"),
                                ' ',
                                React.createElement(Money, { amount: paymentPlanHelpers.getAmount.rest(plan) || 0 })))))),
                        React.createElement("h2", null,
                            plan.length,
                            ' ',
                            React.createElement("span", { style: { fontWeight: 'normal' } }, lang.paymentPlans.entries)),
                        React.createElement("p", null,
                            moment(plan[0] && plan[0].date).format(THEME.DATE_FORMAT_SHORT),
                            ' ',
                            React.createElement(ArrowRight, null),
                            ' ',
                            moment(plan[plan.length - 1] &&
                                plan[plan.length - 1].date).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement("p", null,
                            lang.paymentPlans.totalPayment,
                            ' ',
                            React.createElement("b", null, singleCase === null || singleCase === void 0 ? void 0 :
                                singleCase.currency,
                                ' ',
                                formatNumber(paymentPlanHelpers.getAmount.total(plan)))),
                        React.createElement(ExclusiveContent, null, documents && tenant && creditor && plan && (React.createElement(CalcDiff, { caseVouchers: props.caseVouchers, documents: documents, expirationSettings: getExpirationSettings(tenant, creditor), plan: plan }))),
                        React.createElement("div", null,
                            React.createElement(Table, { zebra: true, sumRow: true, style: {
                                    width: '100%',
                                    marginTop: `${THEME.GRID_SPACING}px`,
                                }, wrapperStyle: {
                                    width: '100%',
                                } },
                                React.createElement("tr", null,
                                    React.createElement("th", null, lang.paymentPlans.entry),
                                    React.createElement("th", { style: { textAlign: 'right' } }, lang.paymentPlans.reminder),
                                    React.createElement("th", { style: { textAlign: 'right' } }, lang.paymentPlans.date),
                                    React.createElement("th", { style: { textAlign: 'right' } }, lang.paymentPlans.lastChanceOfPayment),
                                    React.createElement("th", { style: { textAlign: 'right' } }, lang.paymentPlans.cancelled),
                                    React.createElement("th", { style: { textAlign: 'right' } }, lang.paymentPlans.addedInterests),
                                    React.createElement("th", { style: { textAlign: 'right' } }, lang.paymentPlans.amount)),
                                plan.map((entry, i) => {
                                    return (React.createElement("tr", { key: moment(entry.date).format() +
                                            entry.amount +
                                            entry.type +
                                            entry.status },
                                        React.createElement("td", null,
                                            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, i + 1)),
                                        React.createElement("td", { style: { textAlign: 'right' } }, moment(entry.reminder).format(THEME.DATE_FORMAT_SHORT)),
                                        React.createElement("td", { style: { textAlign: 'right' } },
                                            React.createElement("b", null, moment(entry.date).format(THEME.DATE_FORMAT_SHORT))),
                                        React.createElement("td", { style: { textAlign: 'right' } }, moment(entry.deadline).format(THEME.DATE_FORMAT_SHORT)),
                                        React.createElement("td", { style: { textAlign: 'right' } }, moment(entry.cancel).format(THEME.DATE_FORMAT_SHORT)),
                                        React.createElement("td", { style: { textAlign: 'right' } },
                                            "+",
                                            React.createElement(Money, { amount: tenant != null &&
                                                    creditor != null &&
                                                    documents != null
                                                    ? paymentPlanHelpers.calculateInterestPerEntry(props.caseVouchers, documents, getExpirationSettings(tenant, creditor), plan, i)
                                                    : 0 })),
                                        React.createElement("td", { style: { textAlign: 'right' } },
                                            !!(config === null || config === void 0 ? void 0 : config.amount) && i !== 0 && (React.createElement(Edit, { style: { float: 'left' }, onClick: () => {
                                                    try {
                                                        const amountRaw = prompt(lang.paymentPlans.inputAmount);
                                                        if (!amountRaw ||
                                                            tenant == null ||
                                                            creditor == null ||
                                                            documents == null) {
                                                            return;
                                                        }
                                                        const amount = Math.round(parseFloat(`${amountRaw}`
                                                            .replace(',', '.')
                                                            .replace(/\s/g, '')) * 100);
                                                        if (isNaN(amount) ||
                                                            amount < 0 ||
                                                            amount > 100000000) {
                                                            alert(lang.paymentPlans
                                                                .errorInInput);
                                                            return;
                                                        }
                                                        const newConfig = Object.assign(Object.assign({}, config), { amount, plan: plan
                                                                .slice(0, i)
                                                                .map((p) => (Object.assign(Object.assign({}, p), { amountEdited: true }))) });
                                                        const _plan = helpers.paymentPlans.gen(JSON.parse(JSON.stringify(helpers.vouchers.postProcessing(props.caseVouchers, {
                                                            includeIrrecoverableVouchers: false,
                                                            includeDeletedVouchers: false,
                                                            includeExpiredVouchers: false,
                                                        }))), documents, getExpirationSettings(tenant, creditor), newConfig);
                                                        selectPlan('CUSTOM', _plan, newConfig);
                                                    }
                                                    catch (error) {
                                                        alert(error);
                                                        console.error(error);
                                                    }
                                                } })),
                                            React.createElement("b", null,
                                                React.createElement(Money, { amount: entry.amount || 0 })))));
                                }),
                                React.createElement("tr", null,
                                    React.createElement("td", null),
                                    React.createElement("td", null),
                                    React.createElement("td", null),
                                    React.createElement("td", null),
                                    React.createElement("td", null),
                                    React.createElement("td", { style: { textAlign: 'right' } },
                                        React.createElement(Money, { amount: tenant && creditor && documents != null
                                                ? plan.reduce((acc, entry, i) => {
                                                    return (acc +
                                                        paymentPlanHelpers.calculateInterestPerEntry(props.caseVouchers, documents, getExpirationSettings(tenant, creditor), plan, i));
                                                }, 0)
                                                : 0 })),
                                    React.createElement("td", { style: { textAlign: 'right' } },
                                        React.createElement(Money, { amount: paymentPlanHelpers.getAmount.total(plan) }))))))))) : (React.createElement("div", null, standardPlans &&
                    singleCase &&
                    standardPlans.map((plan) => (React.createElement(Plan, { duration: plan.duration, startDate: moment()
                            .startOf('month')
                            .add(1, 'months')
                            .add(moment().format('HH:mm:ss')), active: selectedPlan === plan.id, singleCase: singleCase, caseVouchers: props.caseVouchers, onSelectPlan: (id, p) => selectPlan(id, p, null), id: plan.id, key: plan.id })))))))))),
        !paymentPlan && (React.createElement("div", { style: {
                position: 'sticky',
                bottom: '0px',
                marginTop: '20px',
                background: 'white',
                padding: '20px 0px',
                borderTop: '1px solid lightgrey',
            } },
            React.createElement(Checkbox, { checked: activationTrigger, onChange: (e) => {
                    setActivationTrigger(e.target.checked);
                }, placeholder: lang.paymentPlans.confirmationCheckbox }),
            (singleCase === null || singleCase === void 0 ? void 0 : singleCase.status) === CaseStatus.ENDED ? (React.createElement(Errors, { errors: [lang.paymentPlans.errorCaseEnded] })) : null,
            React.createElement(Button, { loading: loading, disabled: !(selectedPlan && !paymentPlan) ||
                    (singleCase === null || singleCase === void 0 ? void 0 : singleCase.status) === CaseStatus.ENDED, onClick: createPaymentPlan, block: true, className: "ui-test-9fab98e3" }, lang.paymentPlans.createPaymentPlan))),
        React.createElement("div", null, paymentPlans &&
            singleCase &&
            paymentPlans
                .sort((a, b) => {
                if (moment(a.createdAt) > moment(b.createdAt)) {
                    return -1;
                }
                else if (moment(a.createdAt) < moment(b.createdAt)) {
                    return 1;
                }
                return 0;
            })
                .map((paymentPlan) => (React.createElement(PaymentPlanTable, { key: paymentPlan.paymentPlanId, paymentPlan: paymentPlan },
                React.createElement(PaymentPlanData, { paymentPlan: paymentPlan, tenantId: props.tenantId, caseVouchers: props.caseVouchers, singleCase: singleCase })))))))));
};
export default PaymentPlanCreator;
const PaymentPlanCreatorStyled = styled.div `
  .react-datepicker-wrapper {
    width: auto;
    display: block;
  }

  .react-datepicker__input-container {
    display: block;
  }
`;
const CalcDiff = (props) => {
    const balance = useMemo(() => {
        console.warn('Calculating if there is a diff in payment plan for debug purpose and QA');
        return getBalance(props.caseVouchers, props.documents, props.expirationSettings, props.plan);
    }, [props.caseVouchers, props.plan]);
    if (balance === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("br", null),
        React.createElement(AlertCmp, { message: React.createElement(React.Fragment, null,
                "Amount has a diff. of ",
                React.createElement(Money, { amount: -balance })) })));
};
//# sourceMappingURL=PaymentPlanCreator.js.map